// extracted by mini-css-extract-plugin
export var button = "_d2-7";
export var buttonRow = "_d2-6";
export var fadeIn = "_d2-1";
export var gradient = "_d2-0";
export var panel = "_d2-2";
export var panelIn = "_d2-3";
export var subtitle = "_d2-5";
export var title = "_d2-4";